import cx from 'classnames';
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { useBreakpoint } from '../../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../../constants/commonConstants';

export const EquipmentDescriptionLoader = () => {
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.LG);

  return (
    <div
      className={cx('d-md-flex d-none flex-column row-gap-2', {
        'row-gap-2 w-75': isDesktop,
        'row-gap-1 w-100': !isDesktop
      })}
    >
      <CatSkeleton className="w-25" size="sm" />
      <CatSkeleton className="w-100" size="sm" />
      <CatSkeleton className="w-100 d-lg-block d-md-none" size="sm" />
    </div>
  );
};
